// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-medium":"#5e5e5e","topbar":"_3pl9WLz","title":"_1zm8gbd undefined","title_normal_font":"z62VJUn"};